import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {
  selectedCard: string | null = null;

  toggleCard(card: string): void {
    this.selectedCard = this.selectedCard === card ? null : card;
  }
}
